import openaiLogo from "../assets/img/openai.webp";
import geminiLogo from "../assets/img/gemini-logo.webp";
import anthropicLogo from "../assets/img/anthropic.webp";
import falAiLogo from "../assets/img/fal-ai.webp";
import heygenLogo from "../assets/img/heygen.webp";

export const BYOK_PROVIDERS = [
  { id: "openai", label: "OpenAI API Key", logo: openaiLogo },
  { id: "google", label: "Gemini API Key", logo: geminiLogo },
  { id: "anthropic", label: "Anthropic API Key", logo: anthropicLogo },
  { id: "fal", label: "Fal AI API Key", logo: falAiLogo },
  { id: "heygen", label: "HeyGen API Key", logo: heygenLogo },
];

export const BYOK_PROVIDERS_BY_ID = Object.fromEntries(
  BYOK_PROVIDERS.map((provider) => [provider.id, provider])
);
